{
  "commands": [
    "  Robotics",
    "  Software Engineering",
    "  PCB Design",
    "  Political Science",
    "  Philosophy and Literature"
  ]
}
